<template>
    <v-container fluid>
        <div v-if="!creditNoteLoading">

            <v-row>
                <v-col>
                    <h4 class="text-h4">
                        Credit Note #{{data.code}}
                    </h4>
                    <p class="text-subtitle-1">Credit Note Modification Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="exchangeRateIndexShown = true">
                        <v-icon left>mdi-chart-areaspline-variant</v-icon>
                        currency exchange
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <CreditNoteForm class="ma-2" ref="form" v-model="data" v-if="!creditNoteLoading" :exchange-rate-index-shown.sync="exchangeRateIndexShown" edit-mode/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="handleDiscard">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import CreditNoteForm from "./../../components/purchase/CreditNoteForm.vue"
import PAlert from "./../../components/common/PAlert.vue"
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "CreditNoteEditView",
    components: {
        CreditNoteForm,
        PAlert
    },
    data() {
        return {
            id: null,
            loading: false,
            creditNoteLoading: false,
            alert: {
                value: false,
                title: "Alert",
                content: "Are You Sure",
                callback: null
            },
            data: null,
            perm: permissions,
            exchangeRateIndexShown: false
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID : "purchase/creditNote/findByID",
            pushSupplier: "purchase/supplier/push",
            pushLedgerAccount: "purchase/ledgerAccount/push",
            update: "purchase/creditNote/update",
            snackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = {...this.alert,content: "Are You Sure You Want to save?", value: true, callback: this.save };
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.update(this.data).then(response => {
                this.$router.push({ name: "CreditNoteDisplay", params: { id: response.data.id } })
                this.snackbar({text: "Credit Note Updated Succesfuly", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        handleNewLine() {
            this.$refs.form.addLine()
        },
        handleDiscard() {
            this.alert = {...this.alert,content: "Are You Sure You Want To Discard", value: true, callback: this.discard }
        },
        discard() {
            this.$router.back();
        },
        fetchCreditNote() {
            this.creditNoteLoading = true;
            this.findByID(this.id).then(response => {

                let data = response.data;
                let exchangeRate = data.base_amount / data.amount;

                data.supplier_id = data.supplier.id;
                this.pushSupplier(data.supplier);
                
                data.account_id = data.account.id;

                // map lines
                data.lines = data.lines.map(line => {
                    
                    line.ledger_account_id = line.ledger_account.id;
                    this.pushLedgerAccount(line.ledger_account);
                    
                    return {
                        ...line,
                        document_amount: line.base_amount / exchangeRate,
                        dimension_id: line.dimension ? line.dimension.id : null
                    }
                });
                
                this.data = data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: "error", text: message })
            }).finally(() => {
                this.creditNoteLoading = false
            })
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.fetchCreditNote();
    },
    beforeRouterUpdate(to, from, next){
        this.id = to.params.id;
        this.fetchCreditNote();
        next();
    }
}
</script>

<style>

</style>